import { msg } from '@lingui/core/macro';
import { AnnouncedTeamStatus } from 'modules/teams/domain/enums/announced-team-status';
import { ApplicationStatus } from 'modules/teams/domain/enums/application-status';
import type { MessageDescriptor } from 'shared/i18n';

const FILTER_PENDING = msg`Незаявленные`;
const FILTER_ACCEPTED = msg`Заявленные`;
const FILTER_DECLINED = msg`Отклоненные`;

/**
 * Подписи фильтра статусов заявок первого флоу. Один фильтр работает на двух enum-ах: у команд
 * статусы строчные (`AnnouncedTeamStatus`), у игроков — заглавные (`ApplicationStatus`).
 */
export const APPLICATION_FILTER_LABELS: Record<string, MessageDescriptor> = {
  [AnnouncedTeamStatus.PENDING]: FILTER_PENDING,
  [AnnouncedTeamStatus.ACCEPTED]: FILTER_ACCEPTED,
  [AnnouncedTeamStatus.DECLINED]: FILTER_DECLINED,
  [ApplicationStatus.PENDING]: FILTER_PENDING,
  [ApplicationStatus.ACCEPTED]: FILTER_ACCEPTED,
  [ApplicationStatus.DECLINED]: FILTER_DECLINED,
};

/** Статус команды в списке заявок второго флоу. Команда без заявок (`ANNOUNCED`) ждёт решения. */
export const ANNOUNCED_TEAM_STATUS_LABELS: Record<AnnouncedTeamStatus, MessageDescriptor> = {
  [AnnouncedTeamStatus.ANNOUNCED]: msg`Ожидает решения`,
  [AnnouncedTeamStatus.PENDING]: msg`Ожидает решения`,
  [AnnouncedTeamStatus.ACCEPTED]: msg`Заявлена`,
  [AnnouncedTeamStatus.DECLINED]: msg`Отклонена`,
};

/** Статус заявки игрока в составе команды второго флоу. */
export const PLAYER_APPLICATION_STATUS_LABELS: Record<ApplicationStatus, MessageDescriptor> = {
  [ApplicationStatus.PENDING]: msg`Ожидает решения`,
  [ApplicationStatus.ACCEPTED]: msg`Заявлен`,
  [ApplicationStatus.DECLINED]: msg`Отклонён`,
};
